export default "__VITE_ASSET__Cj1Be8AV__"